import styled from "styled-components"

export const AdHeaderContainer = styled.div`
    height: ${p => p.theme.unit(9)};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`